import axios from 'axios'
import { useQuery } from 'react-query'
import { IraConstraintsResponsePayload, TransferMechanism, CashDirection } from '@Types'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'

export const buildApiUrl = (transferType: TransferMechanism, accountNumber: string, direction: CashDirection) => {
  const baseUrl = getAppConfigSetting('apiUrl')
  return `${baseUrl}${SENTINEL_API}/ira_constraints/${accountNumber}/${transferType}/${direction}`
}

export default function useGetIraConstraints(
  queryKey: string,
  transferType: TransferMechanism,
  accountNumber: string,
  direction: CashDirection
) {
  const getIraConstraintsUrl = buildApiUrl(transferType, accountNumber, direction)
  const getIRAConstraints = async () => {
    const { data } = await axios.get(getIraConstraintsUrl, {
      withCredentials: true
    })
    return data as IraConstraintsResponsePayload
  }

  return useQuery([queryKey, accountNumber], getIRAConstraints, {
    // The query will not execute until the accountNumber exists
    enabled: !!accountNumber
  })
}
